import { createContext, useContext } from 'react';

/**
 * Opens the Related lines tab of the invoice being shown. A line's split
 * suggestion calls it, so the Line Items table needs no prop for it.
 */
export const SplitProposalReviewContext = createContext<
  (() => void) | undefined
>(undefined);

export function useReviewSplitProposal(): (() => void) | undefined {
  return useContext(SplitProposalReviewContext);
}
